import moment from 'moment';
import appointmentStatuses from 'utils/enums/appointment-statuses.enum';
import appointmentTypes from 'utils/enums/appointment-types.enum';
import appointmentVacationDuration from 'utils/enums/appointment-vacation-duration.enum';
import { timeUsFormat } from 'resolvers/date-format.resolver';

const getDatesFromRange = (startDate, endDate, steps = 1) => {
	const dateArray = [];
	let currentDate = new Date(startDate);

	while (currentDate <= new Date(endDate)) {
		dateArray.push(new Date(currentDate));
		currentDate.setUTCDate(currentDate.getUTCDate() + steps);
	}

	return dateArray;
};

export default (
	appointments = [],
	view,
	requestStart,
	requestEnd,
	{
		startOfWork,
		endOfWork,
		timeZone,
		_id: callCenterId,
	} = {},
) => {
	let startOfWorkTime;
	let endOfWorkTime;
	let isWorkingHoursOnIntersectionOfDays;
	let notWorkingHours = [];
	if (startOfWork && endOfWork && timeZone && view !== 'month') {
		const startOfWorkTimeString = `${String(startOfWork.hour).padStart(2, '0')}:${String(startOfWork.minute).padStart(2, '0')}`;
		const endOfWorkTimeString = `${String(endOfWork.hour).padStart(2, '0')}:${String(endOfWork.minute).padStart(2, '0')}`;

		startOfWorkTime = moment.tz(moment().format('YYYY-MM-DD') + ' ' + startOfWorkTimeString, timeZone).toDate();
		endOfWorkTime = moment.tz(moment().format('YYYY-MM-DD') + ' ' + endOfWorkTimeString, timeZone).toDate();

		const startOfWorkTimeHours = startOfWorkTime.getHours();
		const startOfWorkTimeMinutes = startOfWorkTime.getMinutes();
		const endOfWorkTimeHours = endOfWorkTime.getHours();
		const endOfWorkTimeMinutes = endOfWorkTime.getMinutes();

		isWorkingHoursOnIntersectionOfDays =
			startOfWorkTimeHours * 60 + startOfWorkTimeMinutes
			> endOfWorkTimeHours * 60 + endOfWorkTimeMinutes;

		if (isWorkingHoursOnIntersectionOfDays) {
			notWorkingHours = getDatesFromRange(requestStart, requestEnd)
				.reduce((acc, date) => {
					const start = moment(date)
						.set({ hour: endOfWorkTimeHours, minute: endOfWorkTimeMinutes, millisecond: 0 });
					const end = moment(date)
						.set({ hour: startOfWorkTimeHours, minute: startOfWorkTimeMinutes, millisecond: 0 });

					acc.push({
						color: 'light-gray',
						type: appointmentTypes.NOT_WORKING_HOURS,
						start: start.toDate(),
						end: end.toDate(),
					});
					return acc;
				}, []);
		} else {
			notWorkingHours = getDatesFromRange(requestStart, requestEnd)
				.reduce((acc, date) => {
					const firstStart = moment(date);
					const firstEnd = moment(date)
						.set({ hour: startOfWorkTimeHours, minute: startOfWorkTimeMinutes, millisecond: 0 });

					const secondStart = moment(date)
						.set({ hour: endOfWorkTimeHours, minute: endOfWorkTimeMinutes, millisecond: 0 });
					const secondEnd = moment(date).endOf('day');

					acc.push({
						color: 'light-gray',
						type: appointmentTypes.NOT_WORKING_HOURS,
						start: firstStart.toDate(),
						end: firstEnd.toDate(),
					});
					acc.push({
						color: 'light-gray',
						type: appointmentTypes.NOT_WORKING_HOURS,
						start: secondStart.toDate(),
						end: secondEnd.toDate(),
					});
					return acc;
				}, []);
		}
	}

	const result = appointments.map((appointment) => {
		if (callCenterId && appointment.callCenterId && appointment.callCenterId !== callCenterId) {
			return null;
		}
		let color;
		let start = new Date(appointment.startTime);
		let end = new Date(appointment.endTime);

		if (view === 'day' && appointment.type === appointmentTypes.CALL) {
			if (start <= new Date(requestStart)) {
				start = new Date(requestStart);
			}
			if (end >= new Date(requestEnd)) {
				end = new Date(requestEnd);
			}
		}

		if (appointment.type === appointmentTypes.CALL && appointment.status === appointmentStatuses.CONFIRMED) {
			color = 'red';
		} else {
			color = 'default';
		}

		const tooltip = `${moment(appointment.startTime).format(timeUsFormat)} - ${moment(appointment.endTime).add(1, 'seconds').format(timeUsFormat)} - ${appointment.callPurpose || appointment.name}`;
		return {
			title: appointment.callPurpose || appointment.name,
			id: appointment.id,
			start,
			end,
			color,
			tooltip,
			type: appointment.type,
			allDay: appointment.vacationLastingType === appointmentVacationDuration.WHOLE_DAYS,
		};
	});
	result.push(...notWorkingHours);
	return result;
}
